import { apiSlice } from '../../../redux/api'
import { paramsToQuery } from '../../../../react/util/queries'
import { ApiMethods } from '../../../../react/api'

export const jobBoardApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getJobBoardJobs: builder.query({
      query: params => `job-board/jobs${paramsToQuery(params)}`
    }),
    getJobBoardJobPosting: builder.query({
      query: ({ identifier }) => `job-board/jobs/${identifier}`
    }),
    getJobBoardJobCategories: builder.query({
      query: params => `job-board/job-categories${paramsToQuery(params)}`
    }),
    getJobBoardJobTypes: builder.query({
      query: params => `job-board/job-types${paramsToQuery(params)}`
    }),
    subscribeToJobBoard: builder.mutation({
      query: body => ({
        url: 'job-board/subscribe',
        method: ApiMethods.Post,
        body: body
      })
    })
  })
})

export const {
  useGetJobBoardJobsQuery,
  useGetJobBoardJobPostingQuery,
  useGetJobBoardJobCategoriesQuery,
  useGetJobBoardJobTypesQuery,
  useSubscribeToJobBoardMutation
} = jobBoardApi
